<template>
    <div class="router-page">
        <van-grid :column-num="4" :border="false" :gutter="12" style="padding: 0;">
            <van-grid-item v-for="(item, index) in mobileRoutesData"
                v-if="item.role.includes(role) || item.role.length === 0" :icon="item.icon" :text="item.title"
                :to="item.path" :key="index" class="grid-item" />
        </van-grid>
    </div>
</template>

<script>

import { mobileRoutesData } from '@/utils/data/basicData/leftNavData';
import { getDataInLocalStorage } from '@/utils/localStorage';

export default {
    name: "Router",
    components: {
    },
    data() {
        return {
            mobileRoutesData: mobileRoutesData,
        }
    },
    computed: {
        role() {
            return getDataInLocalStorage('role')
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped>
.router-page {
    padding: 16px;
    background: #f7f8fa;
    min-height: 100vh;
}

.grid-item {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    margin:4px 4px 4px 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 12px rgba(100, 101, 103, 0.08);
}

.grid-item:active {
    transform: scale(0.95);
    opacity: 0.8;
}

.grid-item .van-grid-item__icon {
    font-size: 24px;
    text-align: center;
    color: #1989fa;
}
.grid-item :deep(.van-grid-item__content) {
    padding: 16px 8px;
    /* 增加内边距来扩大格子 */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.grid-item .van-grid-item__text {
    margin-top: 8px;
    font-size: 12px;
    color: #323233;
    text-align: center;
}
</style>
